/** Write a resolution (dots per inch) into a JPEG's JFIF header so print shops and portals read 300 DPI. */
export function setJpegDpi(bytes: Uint8Array, dpi: number): Uint8Array {
  if (bytes.length < 4 || bytes[0] !== 0xff || bytes[1] !== 0xd8) return bytes;
  const hi = (dpi >> 8) & 0xff, lo = dpi & 0xff;
  // Existing JFIF APP0 right after SOI: patch units + densities in place.
  if (bytes[2] === 0xff && bytes[3] === 0xe0 && bytes[6] === 0x4a && bytes[7] === 0x46 && bytes[8] === 0x49 && bytes[9] === 0x46) {
    const out = new Uint8Array(bytes);
    out[13] = 1; // units: dots per inch
    out[14] = hi; out[15] = lo; out[16] = hi; out[17] = lo;
    return out;
  }
  // No JFIF header (some browsers omit it): insert one after SOI.
  const app0 = Uint8Array.from([0xff, 0xe0, 0x00, 0x10, 0x4a, 0x46, 0x49, 0x46, 0x00, 0x01, 0x01, 0x01, hi, lo, hi, lo, 0x00, 0x00]);
  const out = new Uint8Array(bytes.length + app0.length);
  out.set(bytes.subarray(0, 2), 0);
  out.set(app0, 2);
  out.set(bytes.subarray(2), 2 + app0.length);
  return out;
}

/** Reads the JFIF density back (for tests and checks). */
export function readJpegDpi(bytes: Uint8Array): number | null {
  if (bytes[2] === 0xff && bytes[3] === 0xe0 && bytes[6] === 0x4a && bytes[7] === 0x46 && bytes[13] === 1) return (bytes[14] << 8) | bytes[15];
  return null;
}
